import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import './index.less'
import { getSlot, hasSlot } from '@/utils/index'
import { VNode } from 'vue/types/umd'

// 使用方法：
//     直接将需要的部分放入对应的插槽，分别为 header，default，footer，
//     其中 footer插槽分为两种模式，一种是普通模式，直接将对应部分放入footer即可，
//     一种是tab模式，需要配合tabKeys使用，同时在插槽中按对应顺序放入不同的tab-pane，例如：<div><comp1 /><comp2 /></div>
@Component
export default class CollapseView extends Vue {
  // tabKeys存在时使用tab模式，不存在即为普通模式
  @Prop() tabKeys
  @Prop() tabKeysExt
  @Prop({default: 0}) defaultTab: number

  toggle = true
  toggleExt = false
  tab = 0
  tabExt = 0

  get allFooterHeight() {
    let i = 0
    if (this.tabKeys && hasSlot(this, 'footer')) i++
    if (this.tabKeysExt && hasSlot(this, 'footerExt')) i++
    return `${64 * i}px`
  }

  @Watch('toggle')
  change(bool) {
    if (bool) {
      if (this.toggleExt) {
        this.toggleExt = false
      }
    }
  }

  @Watch('defaultTab',{immediate:true})
  changeTab() {
    this.tab = this.defaultTab
  }


  @Watch('toggleExt')
  changeExt(bool) {
    if (bool) {
      if (this.toggle) {
        this.toggle = false
      }
    }
  }

  clickTab(index) {
    this.tab = index
    this.$emit('tabClick', this.tab)
  }

  clickTabExt(index) {
    this.tabExt = index
    this.$emit('tabExtClick', this.tab)
  }

  changeY(y) {
    this.$emit('y',y)
  }
  
  render() {
    const footer = getSlot(this, 'footer')
    let tabBar: VNode = null
    let tabPane: VNode | VNode[] = footer
    if (this.tabKeys?.length) {
      tabBar = (
        <div class="tabs">
          {this.tabKeys.map((item, index) => {
            return (
              <div class={index === this.tab ? 'selected tab' : 'tab'} onClick={() => this.clickTab(index)}>
                {item}
              </div>
            )
          })}
        </div>
      )
      tabPane = <div style="height: calc(100% - 34px)">{footer[0]?.children[this.tab]}</div>
    }

    const footerExt = getSlot(this, 'footerExt')
    let tabBarExt: VNode = null
    let tabPaneExt: VNode | VNode[] = footer
    if (this.tabKeysExt?.length) {
      tabBarExt = (
        <div class="tabs">
          {this.tabKeysExt.map((item, index) => {
            return (
              <div class={index === this.tabExt ? 'selected tab' : 'tab'} onClick={() => this.clickTabExt(index)}>
                {item}
              </div>
            )
          })}
        </div>
      )
      tabPaneExt = <div style="overflow: auto">{footerExt[0]?.children[this.tabExt]}</div>
    }

    return (
      <div class="collapse-view-wrapper">
        {getSlot(this, 'header')}
        <div class="body" style={{ marginTop: hasSlot(this, 'header') ? '8px' : '0' }}>
          {getSlot(this)}
        </div>
        <div v-resize={{axis: 'y', cb: this.changeY }}></div>
        {hasSlot(this, 'footer') || hasSlot(this, 'footerExt') ? (
          <div
            class="footer-container"
            style={{ height: !this.toggle && !this.toggleExt ? this.allFooterHeight : '50%' }}
          >
            {hasSlot(this, 'footer') ? (
              <div class={this.toggle ? 'footer' : 'footer shadow'}>
                {tabBar}
                {tabPane}
              </div>
            ) : null}
            {hasSlot(this, 'footerExt') ? (
              <div class={this.toggleExt ? 'footer' : 'footer shadow'}>
                {tabBarExt}
                {tabPaneExt}
                <div
                  class="toggle"
                  onClick={() => ((this.toggleExt = !this.toggleExt), this.$emit('toggleExt', this.toggleExt))}
                >
                  <a-icon type={this.toggleExt ? 'down' : 'up'} style="font-size: 16px" />
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }
}
